import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 上传图片
    save: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/profile/saveProfile`, params),
    //获取图片
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/profile/getProfileList`, params),
}